module.exports = __webpack_public_path__ + "img/foot_left.0f95e269.png";